const preencheComZero = (valor, tamanho) => {
  if (!valor || valor.length > tamanho || valor.length === 0) {
    return false;
  } else {
    let diferenca = tamanho - valor.length;
    let zeros = "";
    for (let i = 0; i < diferenca; i++) {
      zeros += "0";
    }
    return zeros + valor;
  }
};

const certidaoNascimentoAntiga = member => {
  let livro = preencheComZero(member.certidaoNascimentoLivro, 5);
  let folha = preencheComZero(member.certidaoNascimentoFolha, 3);
  let termo = preencheComZero(member.certidaoNascimentoTermo, 7);
  if (livro && folha && termo) {
    return preencheComZero("0", 17) + livro + folha + termo;
  }
  return false;
};

export default {
  certidaoNascimentoAntiga
};
